import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    safeAreaViewContainer: {
        flex: 1
    },
    contentContainer: {
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
